if (!customElements.get('pdp-sticky-atc')) {
  customElements.define(
    'pdp-sticky-atc',
    class PdpStickyAtc extends HTMLElement {
      connectedCallback() {
        this.productInfo = document.querySelector('product-info[data-section]');
        if (!this.productInfo) return;

        this.sectionId = this.productInfo.dataset.section;
        this.bar = this.querySelector('.pdp-sticky-atc');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.button = this.querySelector('.pdp-sticky-atc__button');

        this.button?.addEventListener('click', this.onButtonClick.bind(this));

        // Show the bar once the main buy button has scrolled above the viewport.
        const mainButton = this.mainSubmitButton();
        const target = mainButton || this.productInfo;
        this.observer = new IntersectionObserver(
          ([entry]) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.bar?.classList.toggle('is-visible', scrolledPast);
          },
          { threshold: 0 }
        );
        this.observer.observe(target);

        // Keep price and availability in sync with the variant picker.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            this.syncFromSectionHtml(event.data?.html);
          });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.unsubscribeVariantChange?.();
      }

      mainSubmitButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      onButtonClick() {
        const mainButton = this.mainSubmitButton();
        if (!mainButton) return;
        if (mainButton.hasAttribute('disabled')) {
          mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        mainButton.click();
      }

      syncFromSectionHtml(html) {
        if (!html) return;

        const priceSource = html.getElementById(`price-${this.sectionId}`);
        if (priceSource && this.priceEl) {
          this.priceEl.innerHTML = priceSource.innerHTML;
        }

        const buttonSource = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (buttonSource && this.button) {
          const soldOut = buttonSource.hasAttribute('disabled');
          this.button.toggleAttribute('data-sold-out', soldOut);
          const label = this.button.querySelector('[data-sticky-label]');
          if (label) {
            label.textContent = soldOut
              ? window.variantStrings?.soldOut || label.dataset.soldOutLabel
              : label.dataset.defaultLabel;
          }
        }
      }
    }
  );
}
